import { useEffect, useRef } from 'react';

const useScreenWakeLock = () => {
    const wakeLockRef = useRef(null);

    const requestWakeLock = async () => {
        try {
            if ('wakeLock' in navigator) {
                wakeLockRef.current = await navigator.wakeLock.request('screen');
                console.log('Screen Wake Lock is active.');

                wakeLockRef.current.addEventListener('release', () => {
                    console.log('Wake Lock was released, attempting to re-acquire...');
                    requestWakeLock();
                });
            } else {
                console.warn('Wake Lock API is not supported in this browser.');
            }
        } catch (err) {
            console.error(`Wake Lock error: ${err.name}, ${err.message}`);
        }
    };

    const releaseWakeLock = () => {
        if (wakeLockRef.current) {
            wakeLockRef.current.release();
            wakeLockRef.current = null;
            console.log('Wake Lock released manually.');
        }
    };

    useEffect(() => {
        requestWakeLock();

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                requestWakeLock();
            } else {
                releaseWakeLock();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            releaseWakeLock();
        };
    }, []);
};

const ScreenWakeLock = () => {
    useScreenWakeLock();
    return null;
};

export default ScreenWakeLock;
